function transformToInput() {
  const searchDiv = document.querySelector(".search-home") as HTMLElement;
  const input = searchDiv.querySelector("input") as HTMLInputElement;

  if (searchDiv && input) {
    searchDiv.classList.add("input-visible");
    searchDiv.style.width = "310px";
    searchDiv.style.height = "42px";
    input.style.display = "block";
    input.focus();

    input.addEventListener("blur", () => {
      searchDiv.classList.remove("input-visible");
      input.style.display = "none";
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const searchDiv = document.querySelector(".search-home") as HTMLElement;

  if (searchDiv) {
    searchDiv.addEventListener("click", transformToInput);
  }

  // Adiciona um ouvinte de evento ao documento para detectar cliques fora do elemento .search
  document.addEventListener("click", (event) => {
    const target = event.target as HTMLElement;
    if (!searchDiv.contains(target)) {
      searchDiv.classList.remove("input-visible"); // Remove a classe quando o input é oculto
      searchDiv.style.width = "32px"; // Volta ao estado anterior
      const input = searchDiv.querySelector("input") as HTMLInputElement;
      input.style.display = "none"; // Esconde o input novamente
    }
  });
});

// Mobile navbar

document.addEventListener("DOMContentLoaded", () => {
  const searchHeaderMobile = document.querySelector<HTMLDivElement>(
    ".search-header-mobile"
  );
  if (!searchHeaderMobile) return;

  let originalContent: string | null = null; // Variável para armazenar o conteúdo original

  searchHeaderMobile.addEventListener("click", () => {
    if (!originalContent) {
      // Armazena o conteúdo original somente se ainda não estiver armazenado
      originalContent = searchHeaderMobile.innerHTML;
    }
   
    const input = document.createElement("input");
    input.type = "text";
    input.placeholder = "Pesquisar...";
    input.name = "s";
    searchHeaderMobile.innerHTML = "";
    searchHeaderMobile.appendChild(input);
    input.focus();

    // Adiciona um evento de clique no documento para restaurar o conteúdo original
    document.addEventListener("click", restoreOriginalContent);
  });

  const restoreOriginalContent = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!searchHeaderMobile.contains(target)) {
      if (originalContent) {
        searchHeaderMobile.innerHTML = originalContent;
        originalContent = null; // Reseta a variável para liberar a memória
        document.removeEventListener("click", restoreOriginalContent); // Remove o evento de clique do documento
      }
    }
  };
});
